import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';

import { selectWarehouseAction } from '../actions/warehouse';
import { validateCartAction } from '../actions/cart';

import sendTransaction from '../services/transaction';
import { getListOfCartItemIds } from './helpers';

class ButtonTransaction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      displaySnackBar: false,
      snackBarMessage: '',
    };
  }

  submitCart = async () => {
    const {
      cartItemIds,
      client,
      warehouseId,
      warehouseName,
      reloadWarehouse,
      validateCart,
    } = this.props;
    try {
      this.setState({ isLoading: true });
      await sendTransaction(warehouseId, client.clientId, cartItemIds);
    } catch (err) {
      this.setState({
        isLoading: false,
        displaySnackBar: true,
        snackBarMessage:
          'Une erreur est survenue, veuillez réeesayer ou envoyer un mail à tech@foodles.co',
      });
      return;
    }
    reloadWarehouse(warehouseId, warehouseName);
    validateCart();
    this.setState({
      isLoading: false,
      displaySnackBar: true,
      snackBarMessage: 'La transaction a bien été effectuée',
    });
  };

  render() {
    const { isLoading, displaySnackBar, snackBarMessage } = this.state;
    const { cartItemIds, client, cartTotal, clientHasNoCredit, error } = this.props;
    const isButtonDisabled =
      client.userId === -1 || !cartItemIds.length || clientHasNoCredit || error || isLoading;

    let buttonLabel = 'Valider le panier';
    if (cartTotal > 0) {
      buttonLabel = `${buttonLabel} : ${cartTotal / 100} €`;
    }
    return (
      <div>
        <Button
          variant="contained"
          disabled={isButtonDisabled}
          size="large"
          color="primary"
          onClick={this.submitCart}
        >
          {buttonLabel}
        </Button>
        <Snackbar
          message={snackBarMessage}
          open={displaySnackBar}
          autoHideDuration={1500}
          onClose={() => {
            this.setState({ displaySnackBar: false });
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        />
      </div>
    );
  }
}

ButtonTransaction.propTypes = {
  cartItemIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  client: PropTypes.shape({
    clientId: PropTypes.number,
    userId: PropTypes.number,
    email: PropTypes.string,
  }).isRequired,
  warehouseId: PropTypes.number.isRequired,
  warehouseName: PropTypes.string.isRequired,
  reloadWarehouse: PropTypes.func.isRequired,
  validateCart: PropTypes.func.isRequired,
  cartTotal: PropTypes.number.isRequired,
  clientHasNoCredit: PropTypes.bool.isRequired,
  error: PropTypes.string,
};

ButtonTransaction.defaultProps = {
  error: null,
};

const mapStateToProps = state => {
  const {
    cart,
    client,
    warehouse: { warehouseId, warehouseName },
  } = state;

  return {
    cartItemIds: getListOfCartItemIds(cart.itemQuantitiesById),
    client,
    warehouseId,
    warehouseName,
    cartTotal: cart.totalPrice,
    error: cart.error,
  };
};

const mapDispatchToProps = dispatch => ({
  reloadWarehouse: (id, name) => {
    dispatch(selectWarehouseAction(id, name));
  },
  validateCart: () => {
    dispatch(validateCartAction());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ButtonTransaction);
